import * as React from 'react';
import { Wrapper } from '../components/wrapper';

export const Welcome = (): React.ReactElement => {
  return <Wrapper>Welcome</Wrapper>;
};
